module.exports = __webpack_public_path__ + "item.variations-multiselect-61adfd06.html";